"use client";
const e = Object.freeze({
  blue: "rgb(79, 132, 224)",
  brand: "rgb(15, 88, 214)",
  gray: "rgb(103, 111, 124)",
  green: "rgb(4, 137, 66)",
  orange: "rgb(255, 128, 4)",
  purple: "rgb(120, 30, 147)",
  red: "rgb(204, 0, 0)",
  white: "rgb(255, 255, 255)",
  yellow: "rgb(255, 202, 21)"
}), r = Object.keys(e);
export {
  e as ICON_COLORS,
  r as ICON_COLOR_KEYS
};
